import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();
const LS_KEY = 'psi_cart';

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(LS_KEY, JSON.stringify(items));
  }, [items]);

  function add(product, qty = 1, variant = '') {
    setItems(prev => {
      const key = `${product.id}__${variant}`;
      const existing = prev.find(i => `${i.id}__${i.variant}` === key);
      if (existing) return prev.map(i => `${i.id}__${i.variant}` === key ? { ...i, qty: i.qty + qty } : i);
      return [...prev, {
        id: product.id, name: product.name,
        price: product.price_sell, price_display: product.price_display,
        image_url: product.image_url, slug: product.slug,
        variant, qty,
      }];
    });
  }

  function remove(id, variant = '') {
    setItems(prev => prev.filter(i => !(i.id === id && i.variant === variant)));
  }

  function update(id, variant = '', qty) {
    if (qty < 1) { remove(id, variant); return; }
    setItems(prev => prev.map(i => i.id === id && i.variant === variant ? { ...i, qty } : i));
  }

  function clear() { setItems([]); }

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, update, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() { return useContext(CartContext); }
